import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const languageState = atom<string>({
	key: 'language',
	default: 'en',
	effects_UNSTABLE: [persistAtom]
});
